let IdentityPoolId = '';

const setIdentityPoolId = (newValue) => {
    IdentityPoolId = newValue;
}

export { IdentityPoolId, setIdentityPoolId };



// WEBPACK FOOTER //
// ./src/config.js